function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n            display: inline-flex;\n            flex-direction: column;\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { Field } from "react-final-form";
import { css } from "@emotion/react";
import { TextField } from "@mui/material";
import { DateTimePicker as KeyboardDateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import ErrorMessage from "../../ErrorMessage";
import { DEFAULT_DATE_FORMAT } from "../../../utils/consts";
import makeViewsFromInputFormat from "../../../utils/dateTime";
var KeyboardDateTimePickerField = function(_param) {
    var name = _param.name, label = _param.label, maxDate = _param.maxDate, minDate = _param.minDate, validate = _param.validate, props = _object_without_properties(_param, [
        "name",
        "label",
        "maxDate",
        "minDate",
        "validate"
    ]);
    return /*#__PURE__*/ _jsx(Field, {
        name: name,
        allowNull: true,
        validate: validate,
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ _jsxs("div", {
                css: css(_templateObject()),
                children: [
                    /*#__PURE__*/ _jsx(KeyboardDateTimePicker, _object_spread({
                        inputFormat: DEFAULT_DATE_FORMAT,
                        views: props.inputFormat ? makeViewsFromInputFormat(props.inputFormat) : makeViewsFromInputFormat(DEFAULT_DATE_FORMAT),
                        label: label,
                        maxDate: maxDate,
                        minDate: minDate,
                        renderInput: function(props) {
                            return /*#__PURE__*/ _jsx(TextField, _object_spread({}, props));
                        }
                    }, props, input)),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(ErrorMessage, {
                            children: meta.error
                        })
                    })
                ]
            });
        }
    });
};
export default KeyboardDateTimePickerField;
